import {
  CONTRACTORDERS,
  CONTRACTORDERS_ERROR,
  CONTRACTORDERS_SUCCESS,
  CONTRACTSDETAILS,
  CONTRACTSDETAILS_ERROR,
  CONTRACTSDETAILS_SUCCESS
} from './ContractOrders.actions'

const initialState = {
  data: { WithContract: {}, NoContract: {} },
  details: { csvStructure: [], tableStructure: [] },
  error: null,
  fetched: false,
  fetching: false
}

/**
 * Contract Orders reducer.
 */
const contractOrdersReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case CONTRACTORDERS: {
      return { ...state, fetching: true }
    }
    case CONTRACTORDERS_ERROR:
    case CONTRACTSDETAILS_ERROR: {
      return { ...state, error: payload.error }
    }
    case CONTRACTORDERS_SUCCESS: {
      return { ...state, data: payload, fetching: false, fetched: true, error: null }
    }
    case CONTRACTSDETAILS: {
      return { ...state, details: initialState.details, fetching: true }
    }
    case CONTRACTSDETAILS_SUCCESS: {
      return { ...state, details: payload, fetching: false, fetched: true, error: null }
    }
    default: {
      return state
    }
  }
}

export default contractOrdersReducer
